import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type SiteSettings = Record<string, any>;

export const useSiteSettings = () => {
  return useQuery({
    queryKey: ["site-settings"],
    queryFn: async (): Promise<SiteSettings> => {
      const { data: rows } = await supabase.from("site_settings").select("key, value");
      const map: SiteSettings = {};
      (rows ?? []).forEach((r) => { map[r.key] = r.value; });
      return map;
    },
    staleTime: 60 * 60 * 1000,
    gcTime: 2 * 60 * 60 * 1000,
  });
};
